/* eslint-disable no-case-declarations */
import {
  LANGUAGE_FETCH_SUCCESS,
  LANGUAGE_FETCH_FAIL,
  LANGUAGE_UPDATE_SUCCESS
} from '../constant/actionType';

const initialState = {
  activeLanguages: [],
  languagesWithCompletion: []
};

const languagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LANGUAGE_FETCH_SUCCESS:
      const languagesWithCompletion = action.data.languagesArrayWithCompletion;
      const { activeLanguages } = action.data;
      return { ...state, activeLanguages, languagesWithCompletion };
    case LANGUAGE_FETCH_FAIL:
      console.error(action.error);
      return state;
    case LANGUAGE_UPDATE_SUCCESS:
      return { ...state, activeLanguages: action.activeLanguages };
    default:
      return state;
  }
};

export default languagesReducer;
